/** `data-slot` on the floating call widget's root. */
export const CALL_WIDGET_SLOT = 'voice-widget';

/**
 * Whether an event came from inside the floating call widget.
 *
 * A modal layer (the contact drawer, a dialog) reads any press outside its
 * content as "dismiss me". The widget floats above every page, so a modal that
 * is open during a call has to let End call, Mute, Hold… through instead of
 * closing — pass this to the layer's `onInteractOutside`.
 */
export function isCallWidgetTarget(target: EventTarget | null): boolean {
    return (
        target instanceof Element && target.closest(`[data-slot="${CALL_WIDGET_SLOT}"]`) !== null
    );
}
